import   axios              from 'axios';

import { API_URLS         } from '../urls';

export interface VideoCommentRow {
  id           : number;
  ownerId      : number | null;
  author       : string;
  /** Adresse IP à l'envoi : super-admin seulement, absente des commentaires d'avant le 2026-10-18. */
  ip           : string | null;
  text         : string;
  creationDate : Date | null;
  status       : string;
}

export interface VideoCommentsResult {
  error    : string;
  count    : number;
  comments : VideoCommentRow[];
}

// Tous les commentaires d'une vidéo (fiche vidéo du Dashboard). admin-api contrôle
// l'accès d'après adminId : créateur de la vidéo ou super-admin.
export const getVideoComments = async (adminId: number, videoId: number): Promise<VideoCommentsResult> => {
  try {
    const { data } = await axios.get(API_URLS.getVideoCommentsByVideo, { params: { adminId, videoId } });
    const comments: VideoCommentRow[] = (data?.comments ?? []).map((c: any) => ({
      id           : c.id ?? 0,
      ownerId      : c.ownerId ?? null,
      author       : c.author ?? 'Anonyme',
      ip           : c.ip ?? null,
      text         : c.text ?? '',
      creationDate : c.creationDate ? new Date(String(c.creationDate).replace(' ', 'T')) : null,
      status       : c.status ?? 'approved',
    }));
    return { error: '', count: Number(data?.count ?? comments.length), comments };
  } catch (error) {
    const message = axios.isAxiosError(error) ? (error.response?.data?.error ?? error.message) : 'Erreur inconnue';
    return { error: String(message), count: 0, comments: [] };
  }
};

export interface RecentVideoCommentRow extends VideoCommentRow {
  videoId    : number | null;
  videoTitle : string | null;
  videoPublicRef : string | null;
  creatorId  : number | null;
  creatorName: string | null;
}

export interface RecentVideoCommentsResult {
  error    : string;
  today    : number;
  week     : number;
  comments : RecentVideoCommentRow[];
}

// Commentaires du jour et des 7 derniers jours (tuile de l'onglet Vidéos du Dashboard).
// admin-api limite aux vidéos du compte, tout pour un super-admin, seul à recevoir l'IP.
// `from` / `to` (AAAA-MM-JJ) remplacent les 7 jours par une période (500 au plus).
export const getRecentVideoComments = async (adminId: number, from?: string, to?: string): Promise<RecentVideoCommentsResult> => {
  try {
    const { data } = await axios.get(API_URLS.getRecentVideoComments, { params: { adminId, from: from || undefined, to: to || undefined } });
    const comments: RecentVideoCommentRow[] = (data?.comments ?? []).map((c: any) => ({
      id           : c.id ?? 0,
      ownerId      : c.ownerId ?? null,
      author       : c.author ?? 'Anonyme',
      ip           : c.ip ?? null,
      text         : c.text ?? '',
      creationDate : c.creationDate ? new Date(String(c.creationDate).replace(' ', 'T')) : null,
      status       : c.status ?? 'approved',
      videoId      : c.videoId ?? null,
      videoTitle   : c.videoTitle ?? null,
      videoPublicRef: c.videoPublicRef ?? null,
      creatorId    : c.creatorId ?? null,
      creatorName  : c.creatorName ?? null,
    }));
    return { error: '', today: Number(data?.today ?? 0), week: Number(data?.week ?? comments.length), comments };
  } catch (error) {
    const message = axios.isAxiosError(error) ? (error.response?.data?.error ?? error.message) : 'Erreur inconnue';
    return { error: String(message), today: 0, week: 0, comments: [] };
  }
};
